import Swiper,
{
    Pagination,
    Navigation,
    Autoplay,
    EffectFade,
} from 'swiper';

const params = {
    containerSelector: '.js-hero-slider .swiper-container',
    paginationSelector: '.js-hero-slider .swiper-pagination',
    nextBtnSelector: '.js-hero-next-slide',
    prevBtnSelector: '.js-hero-prev-slide',
};

Swiper.use([Pagination, Navigation, Autoplay, EffectFade]);

export function initHeroSlider() {
    const container = $(params.containerSelector)[0];

    if (!container) {
        return;
    }

    function setActiveFeature(slideIndex) {
        const heroFeatures = $('.hero-feature');
        const activeClass = 'hero-feature-active';
        const currentSlideId = $(`[data-swiper-slide-index="${slideIndex}"]`).data('slide-id');
        const currentFeature = heroFeatures.filter(`[href="${currentSlideId}"]`).first();
        $(heroFeatures).removeClass(activeClass);
        $(currentFeature).addClass(activeClass);
    }

    const heroSliderSwiper = new Swiper(container, {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 20000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
        },
        speed: 1000,
        slidersPerView: 1,
        navigation: {
            nextEl: params.nextBtnSelector,
            prevEl: params.prevBtnSelector,
        },
        pagination: {
            el: params.paginationSelector,
            clickable: true,
        },
        on: {
            slideChange: (swiper) => {
                setActiveFeature(swiper.realIndex);
            },
        },
    });

    // Отключение autoplay на мобилках
    if (BX.browser.IsMobile()) {
        heroSliderSwiper.autoplay.stop();
    }

    $('.hero-feature').each((i, el) => {
        $(el).on('click', (e) => {
            e.preventDefault();
            const slideId = $(el).attr('href');
            const currentSlide = $(`[data-slide-id="${slideId}"]`).first();

            if (currentSlide.length) {
                const slideIndex = currentSlide.data('swiper-slide-index');
                heroSliderSwiper.slideTo(slideIndex + 1);
                setActiveFeature(slideIndex);
            }
        });
    });
}
